/**
 * Compact Subscription Dropdown
 * Updated for Shopify Subscriptions app v81.
 * Defaults to One-time purchase (legally safe).
 * Matches design: radio buttons, prices, highlight on active section.
 */
(function() {
  'use strict';

  var DEFAULT_FREQUENCY = '1';

  function getDefaultFrequency() {
    var variantInput = document.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId) {
      var urlParams = new URLSearchParams(window.location.search);
      variantId = urlParams.get('variant');
    }
    if (variantId) {
      var variantData = document.querySelector('[data-variant-id="' + variantId + '"]');
      if (variantData && variantData.dataset.subscriptionFrequency) {
        return variantData.dataset.subscriptionFrequency;
      }
    }
    var productMetafield = document.querySelector('[data-subscription-default-frequency]');
    if (productMetafield) return productMetafield.getAttribute('data-subscription-default-frequency');
    return DEFAULT_FREQUENCY;
  }

  function extractFrequencyText(text) {
    var multiMatch = text.match(/every\s+(\d+)\s+months?/i);
    if (multiMatch) {
      var num = multiMatch[1];
      return num + (num === '1' ? ' month' : ' months');
    }
    if (text.match(/every\s+month/i)) return '1 month';
    return text.replace(/,\s*\d+%\s*off/i, '').trim();
  }

  function findVisiblePlanCard() {
    var blocks = document.querySelectorAll('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
    for (var i = 0; i < blocks.length; i++) {
      var card = blocks[i].querySelector('.plan_card');
      if (card) return card;
    }
    return document.querySelector('.plan_card');
  }

  function initDropdown() {
    var planCard = findVisiblePlanCard();
    if (!planCard) return false;

    var subscriptionGroups = planCard.querySelectorAll('.subscription_group');
    if (subscriptionGroups.length < 2) return false;
    if (planCard.querySelector('.sub-custom-widget')) return true; // Already done

    var oneTimeGroup = null;
    var subGroup = null;

    subscriptionGroups.forEach(function(group) {
      if (group.querySelector('input[data-radio-type="one_time_purchase"]')) {
        oneTimeGroup = group;
      } else if (group.querySelector('input[data-radio-type="selling_plan"]')) {
        subGroup = group;
      }
    });

    if (!subGroup || !oneTimeGroup) return false;

    // Get prices
    var otPriceEl = oneTimeGroup.querySelector('.in_widget_price');
    var otPrice = otPriceEl ? otPriceEl.textContent.trim() : '';
    var subPriceEl = subGroup.querySelector('.in_widget_price');
    var subPrice = subPriceEl ? subPriceEl.textContent.trim() : '';

    // Get compare-at (original) price for subscription strikethrough
    var firstSubRadio = subGroup.querySelector('input[data-radio-type="selling_plan"]');
    var compareAtPrice = firstSubRadio ? firstSubRadio.getAttribute('data-variant-compare-at-price') : '';

    // Get subscription group name
    var groupNameEl = subGroup.querySelector('.group_name');
    var groupName = groupNameEl ? groupNameEl.textContent.trim() : 'Subscribe & Save 10%';

    // Find default frequency
    var defaultFreq = getDefaultFrequency();
    var frequencyItems = subGroup.querySelectorAll('.group_list li');
    if (frequencyItems.length === 0) return false;

    var selectedItem = frequencyItems[0];
    var defaultSubRadio = null;
    frequencyItems.forEach(function(item) {
      var input = item.querySelector('input[type="radio"]');
      if (input) {
        var ariaLabel = input.getAttribute('aria-label') || '';
        if (defaultFreq === '1' && ariaLabel.match(/every\s+month(?!\s*\d)/i)) {
          selectedItem = item;
        } else if (defaultFreq !== '1' && ariaLabel.indexOf('every ' + defaultFreq + ' month') !== -1) {
          selectedItem = item;
        }
      }
    });
    defaultSubRadio = selectedItem.querySelector('input[type="radio"]');
    var selectedLabel = defaultSubRadio ? (defaultSubRadio.getAttribute('aria-label') || '') : '';

    // ── Build custom widget replacing the plan_card contents ──
    var widget = document.createElement('div');
    widget.className = 'sub-custom-widget';

    // Subscribe & Save row
    var subRow = document.createElement('div');
    subRow.className = 'sub-option sub-option--subscribe';
    subRow.innerHTML =
      '<div class="sub-option__header">' +
        '<div class="sub-option__radio"><span class="sub-radio"></span></div>' +
        '<div class="sub-option__label">' + groupName + '</div>' +
        '<div class="sub-option__price">' +
          '<span class="sub-option__sale-price">' + subPrice + '</span>' +
          (compareAtPrice ? ' <s class="sub-option__compare-price">' + compareAtPrice + '</s>' : '') +
        '</div>' +
      '</div>' +
      '<div class="sub-option__details">' +
        '<div class="sub-option__frequency">' +
          '<span class="sub-option__freq-label">Deliver every</span>' +
          '<div class="sub-option__dropdown-trigger">' + extractFrequencyText(selectedLabel) + '</div>' +
        '</div>' +
        '<div class="sub-option__policy">Auto-renews, skip or cancel anytime.</div>' +
      '</div>';

    // One-time purchase row
    var otRow = document.createElement('div');
    otRow.className = 'sub-option sub-option--onetime sub-option--active';
    otRow.innerHTML =
      '<div class="sub-option__header">' +
        '<div class="sub-option__radio"><span class="sub-radio sub-radio--checked"></span></div>' +
        '<div class="sub-option__label">One-time purchase</div>' +
        '<div class="sub-option__price">' + otPrice + '</div>' +
      '</div>';

    // Dropdown list (hidden, absolute positioned)
    var dropdownList = document.createElement('ul');
    dropdownList.className = 'sub-dropdown-list';
    frequencyItems.forEach(function(item) {
      var input = item.querySelector('input[type="radio"]');
      var ariaLabel = input ? (input.getAttribute('aria-label') || '') : '';
      var freqText = extractFrequencyText(ariaLabel);
      var li = document.createElement('li');
      li.className = (item === selectedItem) ? 'sub-dropdown-item selected' : 'sub-dropdown-item';
      li.textContent = freqText;
      li.setAttribute('data-selling-plan-id', input ? input.getAttribute('data-selling-plan-id') : '');
      dropdownList.appendChild(li);
    });

    widget.appendChild(subRow);
    widget.appendChild(otRow);
    subRow.querySelector('.sub-option__details').appendChild(dropdownList);

    // Hide original plan_card contents, insert custom widget
    Array.from(planCard.children).forEach(function(child) {
      child.style.display = 'none';
    });
    planCard.appendChild(widget);

    // Hide the policy text from the original fieldset
    var fieldset = planCard.closest('.shopify_subscriptions_fieldset');
    if (fieldset) {
      var policy = fieldset.querySelector('.shopify_subscriptions_app_policy');
      if (policy) policy.style.display = 'none';
    }

    // ── State management ──
    var isSubscription = false; // Default to one-time

    function safeSelectRadio(radio) {
      // Check the radio — do NOT dispatch change events (crashes app-embed-block.js).
      // Instead, manually update ALL hidden selling_plan inputs on the page.
      if (!radio) return;
      radio.checked = true;

      // Get the selling plan ID from the radio
      var planId = radio.getAttribute('data-selling-plan-id') || '';
      var radioType = radio.getAttribute('data-radio-type');
      if (radioType === 'one_time_purchase') planId = '';

      // Update ALL hidden selling_plan inputs so the form submits correctly
      document.querySelectorAll('input[name="selling_plan"]').forEach(function(input) {
        input.value = planId;
      });
    }

    function selectOneTime() {
      isSubscription = false;
      otRow.classList.add('sub-option--active');
      subRow.classList.remove('sub-option--active');
      otRow.querySelector('.sub-radio').classList.add('sub-radio--checked');
      subRow.querySelector('.sub-radio').classList.remove('sub-radio--checked');
      subRow.querySelector('.sub-option__details').style.display = 'none';

      var otRadio = oneTimeGroup.querySelector('input[data-radio-type="one_time_purchase"]');
      safeSelectRadio(otRadio);
    }

    function selectSubscribe() {
      isSubscription = true;
      subRow.classList.add('sub-option--active');
      otRow.classList.remove('sub-option--active');
      subRow.querySelector('.sub-radio').classList.add('sub-radio--checked');
      otRow.querySelector('.sub-radio').classList.remove('sub-radio--checked');
      subRow.querySelector('.sub-option__details').style.display = 'block';

      safeSelectRadio(defaultSubRadio);
    }

    // Click handlers
    otRow.addEventListener('click', selectOneTime);
    subRow.addEventListener('click', function(e) {
      if (e.target.closest('.sub-dropdown-list') || e.target.closest('.sub-option__dropdown-trigger')) return;
      selectSubscribe();
    });

    // Dropdown trigger
    var trigger = subRow.querySelector('.sub-option__dropdown-trigger');
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (!isSubscription) selectSubscribe();
      dropdownList.classList.toggle('show');
      trigger.classList.toggle('open');
    });

    // Dropdown item clicks
    dropdownList.querySelectorAll('.sub-dropdown-item').forEach(function(li) {
      li.addEventListener('click', function(e) {
        e.stopPropagation();
        trigger.textContent = li.textContent;
        dropdownList.classList.remove('show');
        trigger.classList.remove('open');
        dropdownList.querySelectorAll('.sub-dropdown-item').forEach(function(l) { l.classList.remove('selected'); });
        li.classList.add('selected');

        // Find and check the matching radio
        var planId = li.getAttribute('data-selling-plan-id');
        var radio = subGroup.querySelector('input[data-selling-plan-id="' + planId + '"]');
        if (radio) {
          defaultSubRadio = radio;
          safeSelectRadio(radio);
        }
      });
    });

    // Close dropdown on outside click
    document.addEventListener('click', function(e) {
      if (!subRow.contains(e.target)) {
        dropdownList.classList.remove('show');
        trigger.classList.remove('open');
      }
    });

    // Default to one-time
    selectOneTime();

    console.log('[Subscription Dropdown] Initialized — defaulting to One-time purchase');
    return true;
  }

  function pollAndInit() {
    var attempts = 0;
    var maxAttempts = 50;
    var interval = setInterval(function() {
      attempts++;
      if (initDropdown()) {
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pollAndInit);
  } else {
    pollAndInit();
  }

  var productInfo = document.querySelector('product-info');
  if (productInfo) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          setTimeout(pollAndInit, 300);
          break;
        }
      }
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  document.addEventListener('variant:change', function() { setTimeout(pollAndInit, 300); });
  document.addEventListener('variant-change', function() { setTimeout(pollAndInit, 300); });
})();
